module.exports = __webpack_public_path__ + "img/bespoke123_28.f05e900f.jpg";